import React from 'react';
import { useTheme } from '@material-ui/core';

import TransferIcon from '@portal/assets/svg/permissions-card/ic_transfer.svg?react';
import PixIcon from '@portal/assets/svg/permissions-card/ic_pix.svg?react';
import TedIcon from '@portal/assets/svg/transfer-icons/ic_ted-doc.svg?react';
import CardIcon from '@portal/assets/svg/permissions-card/ic_card.svg?react';
import UserIcon from '@portal/assets/svg/permissions-card/ic_user.svg?react';
import PayableIcon from '@portal/assets/svg/permissions-card/ic_payable.svg?react';
import SettingsIcon from '@portal/assets/svg/permissions-card/ic_settings.svg?react';
import AdvancedCheckbox from '@portal/components/AdvancedCheckbox/AdvancedCheckbox';
import useReduxState from '@portal/hooks/useReduxState';
import { translate } from '@portal/services/i18n';

import { PermissionsCardType } from '@portal/models/enumerators/cards';

interface PermissionsCardProps {
  title: string;
  type: number | null;
  children?: React.ReactNode;
  onChange: (role: string) => void;
  selectedRoles: string[];
}

const PermissionsCard = ({
  title,
  type,
  onChange,
  selectedRoles,
  children,
}: PermissionsCardProps) => {
  const {
    user: { permissionsList },
  } = useReduxState();

  const { palette } = useTheme();

  return (
    <div className="permissions-card">
      <div className="permissions-card__header">
        {type === PermissionsCardType.TRANSFER && (
          <TransferIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.ALL && (
          <SettingsIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.PIX && (
          <PixIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.TED && (
          <TedIcon
            className="permissions-card__icon"
            fill={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.CARDS && (
          <CardIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.PROFILE && (
          <UserIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.PAYABLE && (
          <PayableIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.RECEIVABLE && (
          <PayableIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {[
          PermissionsCardType.PAYSLIP,
          PermissionsCardType.BILLET,
          PermissionsCardType.P2P,
        ].includes(type as PermissionsCardType) && (
          <PayableIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        {type === PermissionsCardType.EMPLOYEES && (
          <UserIcon
            className="permissions-card__icon"
            color={palette.primary.main}
            width={20}
            height={20}
          />
        )}
        <h3>{title}</h3>
      </div>

      <div className="permissions-card__checkbox">
        {children ? (
          children
        ) : permissionsList?.filter((item) => type === item.type).length > 0 ? (
          permissionsList?.map((item) => {
            if (!item.name) {
              return null;
            }

            if (type === item.type) {
              return (
                <AdvancedCheckbox
                  key={item.value}
                  label={item.name}
                  value={selectedRoles.includes(item.value ?? '')}
                  onChange={() => onChange(item.value ?? '')}
                />
              );
            }
          })
        ) : (
          <p className="permissions-card__no-permissions">
            {translate(
              'PAGES.MY_ACCOUNT.MULTI_ACCESS.TABS.PERMISSIONS.NO_PERMISSIONS'
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default PermissionsCard;
